module.exports = __webpack_public_path__ + "static/media/SVG.3a3196b7.svg";